// extracted by mini-css-extract-plugin
export var readonly = "_cg-1";
export var star = "_cg-0";